import React from 'react';
import JsonData from "../JsonData/jsonData.json";

export default function AllCompnayLogo() {
    return (
        <>
            <section>
                <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
                    <div className="text-center">
                        <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Trusted By Industry Leaders</h2>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 pt-8">
                        {JsonData.companyLogo.map((logo, index) => (
                            <div key={index} className="text-center">
                                <img className="mx-auto h-24" src={`/img/clients/${logo}`} alt={logo.replace("-logo.webp", "").replace(/-/g, " ")} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}
